





































































import { Component, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AclMixin } from '@/components/acl/acl-mixin';
import CreateCampaignDialogCountryMixin from '@/views/reports/mixins/flow/create-campaign-dialog-country-mixin';
import FlowMixin from '@/views/reports/mixins/flow/flow-mixin';
import CreateCampaignDialogFlowOfferErrorsMixin from '@/views/reports/mixins/flow/create-campaign-dialog-flow-offer-errors-mixin';
import Vue from 'vue';

@Component({})
export default class CreateCampaignDialogFlowOffer extends mixins<FlowMixin, CreateCampaignDialogCountryMixin, CreateCampaignDialogFlowOfferErrorsMixin, AclMixin>(FlowMixin,CreateCampaignDialogCountryMixin, CreateCampaignDialogFlowOfferErrorsMixin, AclMixin) {
  @Prop()
  path: any;
  
  @Prop()
  ruleIndex: number;

  @Prop({ default: false })
  isDisabledWeight: boolean;

  @Prop() 
  pathIndex: number;

  @Prop() 
  offerIndex: number;

  @Prop()
  offer: any;

  @Prop()
  offersCount: number;

  @Prop() 
  offersCollection: any[];

  @Prop()
  errorsRaw: any[];

  @Prop({ default: () => [] as string[] })
  errorConditionPrefix: string[];

  @Prop({ default: 0 })
  totalWeight: number;

  @Prop() 
  dialogRepositionParam: string;

  @Emit('delete')
  onDelete() {}

  @Emit('edit')
  onEdit() {}

  @Emit('preview')
  onPreview() {}

  get checkPreviewAccess() {
    const data = this.getItem(this.offer.id)

    if (!data) {
      return true
    }

    return !this.aclCanEditItem({ ...data, type: 'offers' })
  }

  get errorCondition(): any[] {
    return [
      ...this.errorConditionPrefix, 
      ...this.getOfferErrorCondition(this.ruleIndex, this.pathIndex, this.offerIndex)
    ];
  }

  get offerUrl() {
    const offer = this.getItem(this.offer.id);
    return offer ? offer.url : '';
  }

  getItem(id: string) {
    return this.path.offers.find((item: any) => item.id == id);
  }

  get offerPercentage() {
    if (this.totalWeight == 0) { 
      return 0;
    }

    return Math.round(this.offer.weight / this.totalWeight * 100);
  }

  onChange(value) {
    Vue.set(this.path.offers, this.offerIndex, {
      weight:this.offer.weight,
      ...value
    });
  }
}
